import React from 'react';
import type { InstructionPointStyle } from './photoGuidelines.types';
import styles from './InstructionRow.module.css';

interface InstructionRowProps {
  text: string;
  stylesConfig: InstructionPointStyle;
}

const InstructionRow: React.FC<InstructionRowProps> = ({ text, stylesConfig }) => (
  <div className={styles.row}>
    <span className={styles.connectorLine} style={stylesConfig.connectorLine} />
    <span className={styles.lineDot} style={stylesConfig.lineDot} />
    <p className={styles.text} style={stylesConfig.text}>
      {text}
    </p>
  </div>
);

export default InstructionRow;
